var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"textbanner",on:{"click":function($event){return _vm.toggle()}}},[_c('div',{staticClass:"keyline"}),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }